import { EntityClaim } from "../../entity/EntityClaim";

export class DtoClaimsPutRes extends EntityClaim {}
